import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LateFeesComponent } from './components/late-fees/late-fees.component';
import { CoreModule } from '@app/core/core.module';
import { RouterModule } from '@angular/router';
import { LateFeesSummaryComponent } from './components/late-fees-summary/late-fees-summary.component';

@NgModule({
  declarations: [LateFeesComponent, LateFeesSummaryComponent],
  imports: [
    CoreModule,
    CommonModule,
    RouterModule.forChild([
      { path: '', component: LateFeesComponent }
    ]),
  ]
})

export class LateFeesModule { }
